/**
 * @file Photos related mutations.
 */

import gql from 'graphql-tag';

import { PhotoFavoriteDetails } from '../fragments/photo';

export const photosUpload = gql`
  mutation photosUpload($input: PhotosUploadInput!) {
    photosUpload(input: $input) {
      photo_uploads {
        photo_id
        upload_url
      }
    }
  }
`;

export const favoritePhotosCreate = gql`
  mutation favoritePhotosCreate($input: FavoritePhotosCreateInput!) {
    favoritePhotosCreate(input: $input) {
      favorite_photos {
        id
        photo {
          id
          ...PhotoFavoriteDetails
        }
      }
    }
  }
  ${PhotoFavoriteDetails}
`;

export const favoritePhotosDelete = gql`
  mutation favoritePhotosDelete($input: FavoritePhotosDeleteInput!) {
    favoritePhotosDelete(input: $input) {
      success
    }
  }
`;

export const photoBatchCreate = gql`
  mutation photoBatchCreate($input: PhotoBatchCreateInput!) {
    photoBatchCreate(input: $input) {
      photo_batch {
        id
      }
    }
  }
`;

export const photoBatchPhotosUpload = gql`
  mutation photoBatchPhotosUpload($input: PhotoBatchPhotosUploadInput!) {
    photoBatchPhotosUpload(input: $input) {
      photos {
        upload_url
        photo_batch_photo {
          id
          photo {
            id
          }
        }
      }
    }
  }
`;

export const photoBatchPhotosUpdate = gql`
  mutation photoBatchPhotosUpdate($input: PhotoBatchPhotosUpdateInput!) {
    photoBatchPhotosUpdate(input: $input) {
      success
    }
  }
`;

export const reportedPhotosCreate = gql`
  mutation reportedPhotosCreate($input: ReportedPhotosCreateInput!) {
    reportedPhotosCreate(input: $input) {
      reported_photos {
        id
      }
    }
  }
`;

export const photoUpdate = gql`
  mutation photoUpdate($input: PhotoUpdateInput!) {
    photoUpdate(input: $input) {
      photo {
        id
        description
      }
    }
  }
`;

export const photoForegroundUpdate = gql`
  mutation photoForegroundUpdate($input: PhotoForegroundUpdateInput!) {
    photoForegroundUpdate(input: $input) {
      photo_foreground {
        original_url {
          url
        }
        watermarked_original_url {
          url
        }
        thumbnail_urls {
          url
          width
          height
          size_code
        }
        watermarked_thumbnail_urls {
          url
          width
          height
          size_code
        }
        status
      }
    }
  }
`;
